<template>
  <modal
    :showModal="showModal"
    @close-modal="$emit('close-modal')"
    title="Edit Fleet"
    width="30"
  >
    <div class="my-2">
      <p class="">
        Edit Selected Fleet
      </p>
    </div>

    <div class="particulars-img-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Name</label>
            <input type="text" v-model="fleet.equipment" class="input" />
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">VIN/Chassis</label>
            <input
              type="text"
              :disabled="true"
              v-model="fleet.vinnumber"
              class="input cursor-not-allowed"
            />
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Vehicle Type</label>

            <el-select v-model="fleet.vehicletype" placeholder="Select Type">
              <el-option label="Truck" value="Truck"></el-option>
              <el-option label="Bus" value="Bus"></el-option>
              <el-option label="van" value="van"></el-option>
              <el-option label="Lorry" value="Lorry"></el-option>
              <el-option label="Car" value="car"></el-option>
            </el-select>
          </div>

          <!-- <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Date of Registration</label>
            <el-date-picker
              class="w-full"
              style="width: 100%"
              v-model="fleet.registerDate"
              type="date"
              placeholder="Pick a date"
            >
            </el-date-picker>
          </div> -->

          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">
                  The default terminal identifies the base<br /><br />
                  location for this fleet
                </div>

                <span class="flex">
                  <abbr class="mr-2">Terminals </abbr>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.5 7H9.5V5H11.5V7ZM11.5 15H9.5V9H11.5V15ZM10.5 0C9.18678 0 7.88642 0.258658 6.67317 0.761205C5.45991 1.26375 4.35752 2.00035 3.42893 2.92893C1.55357 4.8043 0.5 7.34784 0.5 10C0.5 12.6522 1.55357 15.1957 3.42893 17.0711C4.35752 17.9997 5.45991 18.7362 6.67317 19.2388C7.88642 19.7413 9.18678 20 10.5 20C13.1522 20 15.6957 18.9464 17.5711 17.0711C19.4464 15.1957 20.5 12.6522 20.5 10C20.5 8.68678 20.2413 7.38642 19.7388 6.17317C19.2362 4.95991 18.4997 3.85752 17.5711 2.92893C16.6425 2.00035 15.5401 1.26375 14.3268 0.761205C13.1136 0.258658 11.8132 0 10.5 0Z"
                      fill="#383F51"
                    />
                  </svg>
                </span>
              </el-tooltip>
            </label>

            <el-select v-model="fleet.routes" placeholder="Select Route">
              <el-option
                :label="route.routeName"
                :value="route.id"
                v-for="route in routes"
                :key="route.id"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Carriage Capacity</label>
            <input type="text" v-model="fleet.carriageCapacity" class="input" />
          </div>

          <!-- <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Date Registered</label>
            <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
          </div> -->

          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Vehicle Status</label>
            <el-select v-model="fleet.fleetstatus" placeholder="Select state">
              <el-option label="Active" value="active"> </el-option>
              <el-option label="In Active" value="inactive"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <button @click="$emit('close-modal')">Cancel</button>
      <base-button text="Save" :disabled="disableButton" @click="updateFleet" />
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    fleet: Object,
    fleetID: String,
    routes: Array,
    editingFleet: Object,
    particularsName: {
      required: false,
      default: "Licence & Registration",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    disableButton() {
      return false;
    },
  },

  methods: {
    async updateFleet() {
      this.loading = true;

      try {
        await this.$_updateFleet(this.fleetID, {
          equipment: this.fleet.equipment,
          vehicletype: this.fleet.vehicletype,
          fleetstatus: this.fleet.fleetstatus,
          carriageCapacity: this.fleet.carriageCapacity,
          currentLoadCapacity: this.fleet.currentLoadCapacity,
          routes: this.fleet.routes,
          registerDate: this.fleet.registerDate,
        });

        this.generateToast("Fleet has been updated successfully", "success");
        this.resetInputFied();
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    resetInputFied() {
      this.newVehicle = {
        equipment: "",
        vinnumber: "",
        chassisnumber: "",
        assettag: "",
        terminals: "",
        routes: "",
        vehicletype: "",
        carriageCapacity: "",
        currentLoadCapacity: "",
        vehicleparticulars: [],
      };
    },

    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
</style>
